import type {Components, Theme} from '@mui/material/styles';
import {formControlColorStates} from '../shared/form-control-color-states';

const SWITCH_DISABLED_THUMB_COLOR = '#f5f5f5';
const SWITCH_DISABLED_TRACK_COLOR = 'rgba(0, 0, 0, 0.12)';

export const switchOverrides: Components<Theme>['MuiSwitch'] = {
    styleOverrides: {
        switchBase: {
            ...formControlColorStates('MuiSwitch'),
            '&.Mui-disabled': {
                '& .MuiSwitch-thumb': {
                    backgroundColor: SWITCH_DISABLED_THUMB_COLOR,
                },
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: SWITCH_DISABLED_TRACK_COLOR,
                },
            },
        },
    },
};
